import React, { useRef } from 'react';
import { useTranslation } from "react-i18next";
import Slider from "react-slick";
import { OfferCardJSX } from '../offerCard/offerCard';
import dropbox from "../../../assets/images/dropbox.svg";
import styles from './offerCardList.module.css';
import { Link } from "react-router-dom";

export const OfferCardListJSX = (props) => {
  const { t } = useTranslation();
  const localSliderRef = useRef(null);

  const {
    SubCatTitle,
    SubCatText,
    offerparentInstitutionCategory,
    SubCatTextLineOne,
    SubCatTextLineTwo,
    offerData,
    redirectUrl,
    isDescription,
    isSlider,
    profileData,
    mainCatID,
    instituteID,
    sliderRef // External ref passed from parent
  } = props;

  // Use external ref if provided, otherwise use local ref
  const activeSliderRef = sliderRef || localSliderRef;

  const hitShowALL = () => {
    // Reset slider to beginning before navigation
    if (activeSliderRef.current) {
      activeSliderRef.current.slickGoTo(0);
    }

    if (mainCatID) {
      localStorage.setItem("selectCategory", mainCatID);
    }
    if (instituteID) {
      localStorage.setItem("selectCategory", instituteID);
    }
  }

  const settings = isSlider ?
    {
      dots: false,
      infinite: false,
      initialSlide: 0,
      speed: 500,
      arrows: true,
      adaptiveHeight: true,
      slidesToShow: 2,
      slidesToScroll: 1,
      centerMode: false,
      centerPadding: '20px',
      responsive: [
        {
          breakpoint: 1024,
          settings: {
            slidesToShow: 2,
            slidesToScroll: 1,
            infinite: false,
            arrows: true,
            dots: false,
            initialSlide: 0
          }
        },
        {
          breakpoint: 600,
          settings: {
            slidesToShow: 1,
            slidesToScroll: 1,
            initialSlide: 0,
            arrows: true,
            dots: false
          }
        },
        {
          breakpoint: 480,
          settings: {
            slidesToShow: 1,
            slidesToScroll: 1,
            arrows: true,
            dots: false,
            initialSlide: 0
          }
        }
      ]
    } : {
      infinite: true,
      speed: 500,
      slidesToShow: 2,
      slidesToScroll: 1,
      arrows: true,
      initialSlide: 0,
      responsive: [
        {
          settings: "unslick",
          breakpoint: 5000,
        },
      ],
    };

  return (
    <div className="container">
      <div className={
        isDescription
          ? `${styles.textalign}`
          : `${offerparentInstitutionCategory}`
      }>
        {SubCatTitle !== "" && <h2>{SubCatTitle}</h2>}
        {SubCatTitle !== "" && (
          <h6>
            {SubCatText} <br />{SubCatTextLineTwo} {SubCatTextLineOne}
          </h6>
        )}
      </div>

      <div className="row offersss">
        {offerData?.length > 0 ? (
          <Slider {...settings} ref={activeSliderRef}>
            {offerData.map((offer, index) => (
              <div
                key={offer?.id || offer?.offerName || index}
                className={isSlider ? "col-lg-12 col-md-12 col-sm-12 col-xs-12" : `${styles.gridblock} col-lg-6 col-md-6 col-sm-12 col-xs-12`}
              >
                <OfferCardJSX
                  offerimgurl={offer?.imageUrl}
                  offerparentInstitutionCategory={offer?.parentInstitutionCategory}
                  offervalidTo={offer?.validTo}
                  offerofferName={offer?.offerName}
                  offerdescription={offer?.description}
                  offerexternalUrl={offer?.externalUrl}
                  isDescription={isDescription}
                />
              </div>
            ))}
          </Slider>
        ) : (
          <div className="dropdefault text-center">
            <div className="dropdefaultimage">
              <img src={dropbox} alt="dropbox" />
            </div>
            <div className="dropdefaulttext">
              <h5 className="opacity0">{t("COMMON.NOTFOUND")}</h5>
            </div>
          </div>
        )}

        {isSlider && (
          <div className="latestbutton margintop dasof" onClick={() => hitShowALL()}>
            <Link
              to={{
                pathname: redirectUrl,
                state: { data: profileData, frompage: 'ppvAdsSection', pagePath: redirectUrl }
              }}
              className="showallourbesttoo"
              style={{ textDecoration: "none" }}
            >
              {t("COMMON.SHOWALL")}
            </Link>
          </div>
        )}
      </div>
    </div>
  );
};